import React, {useEffect, useState} from 'react';
import DocxViewer from '@components/common/DocxViewer/DocxViewer';
function VaccinationPackage1() {
    return <DocxViewer fileUrl="https://betaweb.tnh.com.vn/bw_documents/goi-kham-suc-khoe-tam-soat-ung-thu-som.docx" />;
}

export default VaccinationPackage1;
